(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sales-notification-popup"] && !Shopify.designMode) return;
  try {
    
  class SalesNotificationPopup extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-sales-notification-item]'));
      this.closeButton = this.querySelector('[data-sales-notification-close]');
      this.initialDelay = Number(this.dataset.initialDelay || 3000);
      this.displayDuration = Number(this.dataset.displayDuration || 6000);
      this.interval = Number(this.dataset.interval || 12000);
      this.randomize = this.dataset.randomize === 'true';
      this.showOnce = this.dataset.showOnce === 'true';
      this.storageKey = `sales-notification-dismissed-${this.dataset.sectionId}`;
      this.currentIndex = -1;

      if (!this.items.length) {
        return;
      }

      if (this.showOnce && sessionStorage.getItem(this.storageKey)) {
        return;
      }

      this.closeButton?.addEventListener('click', () => this.dismiss());
      this.startTimer = window.setTimeout(() => this.showNext(), this.initialDelay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.startTimer);
      window.clearTimeout(this.hideTimer);
      window.clearTimeout(this.nextTimer);
    }

    showNext() {
      const update = () => {
        this.hidden = false;
        this.items.forEach((item) => {
          item.hidden = true;
          item.classList.remove('is-visible');
        });

        this.currentIndex = this.getNextIndex();
        const item = this.items[this.currentIndex];
        item.hidden = false;

        requestAnimationFrame(() => item.classList.add('is-visible'));
        this.hideTimer = window.setTimeout(() => this.hideCurrent(), this.displayDuration);
      };

      if (document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    hideCurrent() {
      const item = this.items[this.currentIndex];

      if (item) {
        item.classList.remove('is-visible');
      }

      this.nextTimer = window.setTimeout(() => this.showNext(), this.interval);
    }

    getNextIndex() {
      if (this.items.length === 1) {
        return 0;
      }

      if (this.randomize) {
        let nextIndex = Math.floor(Math.random() * this.items.length);

        if (nextIndex === this.currentIndex) {
          nextIndex = (nextIndex + 1) % this.items.length;
        }

        return nextIndex;
      }

      return (this.currentIndex + 1) % this.items.length;
    }

    dismiss() {
      if (this.showOnce) {
        sessionStorage.setItem(this.storageKey, 'true');
      }

      window.clearTimeout(this.startTimer);
      window.clearTimeout(this.hideTimer);
      window.clearTimeout(this.nextTimer);
      this.hidden = true;
    }
  }

  if (!customElements.get('sales-notification-popup')) {
    customElements.define('sales-notification-popup', SalesNotificationPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
